import FileDownloader from "@/components/FileDownloader/FileDownloader";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import { useExportProductLCA as useExportProductLca } from "@/pages/products/useProducts";
import { ExportOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";

export default function ExportProductLcaAction({
  metric,
  year,
  productId,
  onSuccess,
}: {
  metric: ImpactMetric;
  year?: number;
  productId: number;
  onSuccess?: () => void;
}) {
  const exportProductLCA = useExportProductLca();

  if (!year) return <></>;

  return (
    <FileDownloader
      fileUrlFn={() => exportProductLCA.mutateAsync({ metric, year, productId })}
      onFinish={onSuccess}
      customRender={(props) => (
        <Tooltip
          title="Export LCA"
          placement="bottom"
        >
          <Button {...props}>
            <ExportOutlined />
          </Button>
        </Tooltip>
      )}
    />
  );
}
